import(/* webpackMode: "eager" */ "/vercel/path0/apps/frontend/app/page.tsx");
